<template>
    <div class="app">
        <h3>医总管平台用户协议</h3>
        <h4 style="text-align: right; padding-right: 0.5rem;font-weight: normal;">版本生效日期：{{year}}年{{month}}月{{day}}日</h4>
        <h4>重要须知：</h4>
        <p style="">
            &nbsp;&nbsp;本协议是您与医总管全科医生平台（以下简称平台）及其合作单位之间关于医总管（详见定义条款）提供的各种产品及服务（以下统称：医总管产品）所签订的法律协议。医总管在此特别提醒，在您使用医总管产品或接受医总管服务前，请务必认真阅读本服务协议中各条款，包括免除或者限制协议各方的免责条款及权利制约。您须审阅并确认接受本协议条款后，方可继续完成注册并使用医总管产品。未成年人的审阅、确认及使用应在法定监护人的陪同下进行。如您不同意本协议条款及医总管对其进行的调整及修改，您将不能使用或应主动取消医总管平台提供的产品及服务。否则，您的任何对医总管产品的下载、登陆、查看、交易、咨询及其他使用行为将被视为您对本协议条款全部的完全接受，包括接受医总管对协议条款做出的任何调整及修改。
        </p>
        <p>&nbsp;&nbsp;为将被视为您对本协议条款全部的完全接受，包括接受医总管对协议条款做出的任何调整及修改。
            您应该理解平台医生会员开展网上服务的性质和内容，相关咨询问题回答属参考建议性内容，不能替代执业医师的面对面诊断及必要的医学检查，也不能作为最终的诊断结论及治疗的依据，您不可按照平台医生和医生会员给出的建议自行购买药品，更不可按照平台医生和医生会员在网站提供的咨询参考建议自行实施治疗。如出现按照网站医生和医生会员的建议自行购买药品、自行实施治疗等医疗行为，导致的一切后果将由您自行承担。
        </p>
        <p>&nbsp;&nbsp;医总管提供的网络服务内容可能包括：文字、软件、声音、图片、录像、图表等。所有这些内容受版权、商标和其它财产所有权法律的保护。您只有在注册成为医总管会员之后才能使用这些服务内容。但不能擅自复制、篡改上述内容、或未经授权创制以上述内容为基础的有关派生产品。
        </p>
        <p>&nbsp;&nbsp;所有转诊类服务，均需按照国家分级诊疗相关政策规定与平台合作全科医生建立签约关系后，才可享受。若您选择接受转诊类服务，则代表您同意相关医生有权查阅其个人健康档案、就诊病历等资料。
        </p>
        <p>&nbsp;&nbsp;您若违反本协议条款约定，医总管有权随时中止或终止您对医总管的使用资格并保留追究相关法律责任的权利。
        </p>
        <h4>一、定义</h4>
        <p>&nbsp;&nbsp;医总管平台规则：包括在所有医总管平台产品规则内已经发布及后续发布的全部规则、解读、公告等内容以及帮助中心内发布的各类规则、实施细则、产品流程说明、公告等。
        </p>
        <p>&nbsp;&nbsp;同一用户：使用同一身份认证信息、支付帐户或经医总管排查认定多个医总管账户的实际控制人为同一人的，均视为同一用户。
        </p>
        <h4>二、协议主体和范围</h4>
        <p>&nbsp;&nbsp;本协议由您与医总管平台方、产品及服务提供方共同缔结，本协议对您与医总管平台方、产品及服务提供方均具有合同效力。产品及服务提供方还有可能因为提供新的平台服务而新增，如您使用新增的平台服务，视为您同意新增的平台服务者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。
        </p>
        <p>&nbsp;&nbsp;本协议包括协议正文及其规则、须知等，所有规则、须知等补充约定均为本协议不可分割的一部分，与协议具有同等法律效力。
        </p>
        <h4>三、账号注册和使用范围</h4>
        <p style="padding: 0 ;padding-top:0.5rem; ">（一）用户资格（包含个人用户和集团用户两种帐号）
        </p>
        <p>&nbsp;&nbsp;您确认，在您开始注册程序使用医总管平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
        </p>
        <p style="padding: 0">（二）医生资格
        </p>
        <p>&nbsp;&nbsp;为保证平台的严肃性和科学性，同时也为了用户享受更好的服务，如您欲注册医生会员，需提交身份证、职业医师资格证、医师职称证等证明材料，经平台审核无误通过认证后，医生会员方注册成功，可提供相应服务。
        </p>
        <p style="padding: 0">（三）账户说明
        </p>
        <p>&nbsp;&nbsp;1、您有权使用您设置或确认的手机号码或其他账户名及密码（账户名称及密码合称“账户”）登录医总管平台。
        </p>
        <p>&nbsp;&nbsp;2、由于用户账户关联用户个人信息及信用信息，仅当有法律明文规定、司法裁定或经医总管同意，并符合医总管平台规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务将一并转移。除此外，您的账户不得以任何方式转让，否则由此产生的一切后果及责任均由您自行承担。
        <p>&nbsp;&nbsp;3、法律并未赋予医总管强制要求所有用户进行账户实名认证的权利，但为使您更好地使用医总管平台的各项服务，建议您按照平台要求及我国法律规定完成实名认证。
        </p>
        <p>&nbsp;&nbsp;4、如您的信息变更，您应当及时予以更新，在法律有明确规定要求医总管作为平台服务提供者必须对部分用户（如医生等）的信息进行核实的情况下，医总管将依法对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。
        </p>
        <p>&nbsp;&nbsp;如医总管按您最后一次提供的信息与您联系未果、您未按医总管的要求及时提供信息、您提供的信息存在明显不实的，您将承担因此对您自身、他人及医总管造成的全部损失与不利后果。
        </p>
        <h4>四、医总管平台服务及规范</h4>
        <p style="padding: 0;padding-top:0.5rem;">（一）产品及服务内容
        </p>
        <p>1、签约全科医生（具体签约套餐包内容请查看平台对应位置）
        </p>
        <p>&nbsp;&nbsp;1)基本公共卫生服务套餐包
        </p>
        <p>&nbsp;&nbsp;2)增值服务套餐包
        </p>
        <p>2、转诊服务
        </p>
        <p>&nbsp;&nbsp;1)双向转诊
        </p>
        <p>&nbsp;&nbsp;2)视频预约
        </p>
        <p>&nbsp;&nbsp;3)电话预约
        </p>
        <p>&nbsp;&nbsp;4)报告解析
        </p>
        <p>&nbsp;&nbsp;5)影像会诊
        </p>
        <p>&nbsp;&nbsp;6)电视远程医疗健康咨询服务
        </p>
        <p>&nbsp;&nbsp;7)分级诊疗绿色通道或双向转诊预约排号
        </p>
        <p style="padding: 0;">（二）产品或服务的购买与评价
        </p>
        <p style="padding-bottom: 0">1、产品或服务的购买
        </p>
        <p>&nbsp;&nbsp;当您在医总管平台购买服务时，请您务必仔细确认所购产品或服务的种类、价格、数量、型号、规格或服务的时间、内容、限制性要求等重要事项，并需在下单时与您的签约全科医生或平台客服咨询核实您的相关信息，如您购买的服务与您的需求不符，则产生的损失和后果将由您自行承担。
        </p>
        <p>&nbsp;&nbsp;您的购买行为应当基于真实的消费需求，不得存在对商品及/或服务实施恶意购买、恶意维权等扰乱医总管平台正常交易秩序的行为。基于维护医总管平台交易秩序及交易安全的需要，医总管发现上述情形时有权主动执行关闭相关交易订单等操作。
        </p>
        <p>2、评价
        </p>
        <p>&nbsp;&nbsp;您有权在医总管平台提供的评价系统中对您使用或购买的商品及/或服务进行评价。您应当理解，您在医总管平台的评价信息是公开的，且是默认以匿名形式在页面上展示出评价内容。
        </p>
        <p>&nbsp;&nbsp;您的所有评价行为应遵守医总管平台规则的相关规定，评价内容应当客观真实，不应包含任何污言秽语、色情低俗、广告信息及法律法规或本协议列明的其他禁止性信息；您不应以不正当方式利用评价权利对服务提供者实施诽谤、威胁或敲诈勒索。否则，医总管有权对您实施上述行为所产生的评价信息进行删除或屏蔽。
        </p>
        <p style="padding: 0;">（三）支付规则
        </p>
        <p>&nbsp;&nbsp;1、如您为无民事行为能力人或者限制民事行为能力人，则您应在监护人监护、指导下阅读本协议和使用本服务。若您非自然人，请确认，在您取得医总管账户时，或您以其他医总管允许的方式实际使用医总管服务时，您为在中国大陆地区合法设立并开展活动或其他业务的法人或其他组织，且您订立并履行本协议不受您所属、所居住或开展活动或其他业务的国家或地区法律法规的排斥。不具备前述条件的，则您应立即终止注册或停止使用医总管服务。
        </p>
        <p>&nbsp;&nbsp;2、您在使用医总管服务时，须自主选择服务提供方并自行决定是否使用医总管平台与对方进行交易，您应了解并自行承担与此相关的所有风险。
        </p>
        <p>&nbsp;&nbsp;3、您确认，您在医总管上发生的所有交易，已经不可撤销地授权医总管按照《医总管全科医生平台服务协议》、《交易超时规则》等规则进行处理。同时，您不可撤销地授权医总管按照用户交易指令将交易款项的全部或部分支付给交易一方或双方。 医总管按照指令进行资金的止付、扣划完全来自于您的授权，医总管对因此给您造成的任何损失均不承担责任。
        </p>
        <p style="padding: 0;">（四）支付服务
        </p>
        <p>&nbsp;&nbsp;1、支付服务（或称“本服务”）是医总管向您提供的非金融机构支付服务，是受您委托代您收款或付款的资金转移服务，具体服务项目及内容请见平台。
        </p>
        <p>&nbsp;&nbsp;2、除本协议另有规定外, 您在使用支付服务时，点击确认已接受服务或收货后, 医总管即有权将您已支付的款项代为支付给服务方或商家。
        </p>
        <p>&nbsp;&nbsp;3、除本协议另有规定外, 您与交易对方发生交易纠纷时, 您不可撤销地授权医总管自行判断并决定将争议款项的全部或部分支付给交易一方或双方。
        </p>
        <p>&nbsp;&nbsp;4、您在使用本服务过程中，本协议内容、网页或客户端、电视上出现的关于操作的提示或医总管发送到您手机的信息（短信或电话等）内容是您使用本服务的相关规则，对上述规则有异议时请您停止使用本服务，您使用本服务即表示您同意接受本服务的相关规则。您了解并同意医总管有权根据客观情况修改本服务的相关规则，而无须征得您的同意，本服务的相关规则应以您使用服务时的页面提示（或发送到您手机的短信、微信、电话或客户端通知等）为准，您同意并遵照本服务的相关规则是您使用本服务的前提。
        </p>
        <p>&nbsp;&nbsp;4、您在使用本服务过程中，本协议内容、网页或客户端、电视上出现的关于操作的提示或医总管发送到您手机的信息（短信或电话等）内容是您使用本服务的相关规则，对上述规则有异议时请您停止使用本服务，您使用本服务即表示您同意接受本服务的相关规则。您了解并同意医总管有权根据客观情况修改本服务的相关规则，而无须征得您的同意，本服务的相关规则应以您使用服务时的页面提示（或发送到您手机的短信、微信、电话或客户端通知等）为准，您同意并遵照本服务的相关规则是您使用本服务的前提。
        </p>
        <p>&nbsp;&nbsp;5、医总管会以网站公告、电子邮件、发送到您手机的短信、微信、电话、站内信或客户端通知等方式向您发送通知，例如通知您交易及服务进展情况、提示您进行相关操作等，您应及时予以关注。但由于电子数据传输的特殊性，医总管不保证您能够收到或者及时收到该等通知，且对此不承担任何责任。
        </p>
        <p>&nbsp;&nbsp;6、在使用本服务过程中，因您没有及时对交易状态进行修改、确认或未能提交相关申请而导致的任何纠纷或损失，医总管不负任何责任。
        </p>
        <p style="padding: 0;">（五）交易争议的处理
        </p>
        <p>&nbsp;&nbsp;1、医总管平台上产生的交易争议默认由平台协同服务中心仲裁部门进行争议调处服务，医总管平台的仲裁客服作为独立的第三方将根据其所了解的争议事实及医总管平台规则作出调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。在医总管平台调处决定作出前，您可选择其他途径解决争议以中止或终止医总管平台的争议调处服务。
        </p>
        <p>&nbsp;&nbsp;2、如您对调处决定不满意，您有权依法采取诉讼等其他争议处理途径解决争议，但通过其他争议处理途径未取得终局裁决前，您仍应先履行调处决定。
        </p>
        <p>&nbsp;&nbsp;3、其他争议处理途径：
        </p>
        <p>&nbsp;&nbsp;1）、与争议相对方自主协商；
        </p>
        <p>&nbsp;&nbsp;2）、请求消费者协会或者其他依法成立的调解组织调解；
        </p>
        <p>&nbsp;&nbsp;3）、向有关行政部门投诉；
        </p>
        <p>&nbsp;&nbsp;4）、根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；
        </p>
        <p>&nbsp;&nbsp;5）、向人民法院提起诉讼。
        </p>
        <h4>五、用户信息的提供、保护及授权</h4>
        <p>&nbsp;&nbsp;1、医总管非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，您的真实姓名/名称、地址、电话、邮箱等隐私信息，医总管将予以严格保密，除非得到您的授权或有权部门依法调取外，医总管不会对外披露您的任何隐私信息。在您使用医总管产品及服务时，您同意医总管按照在平台上公布的隐私权政策获取、使用、保护您的个人信息。
        </p>
        <p>&nbsp;&nbsp;2、医总管不会对外公开或向第三方提供用户注册资料及用户使用医总管平台时产生的其他非公开信息，但下列情况除外：
        </p>
        <p>&nbsp;&nbsp;1）、事先获得用户的授权；
        </p>
        <p>&nbsp;&nbsp;2）、根据有关法律法规的要求；
        </p>
        <p>&nbsp;&nbsp;3）、按照相关政府有权部门的要求；
        </p>
        <p>&nbsp;&nbsp;4）、为维护社会公众的利益；
        </p>
        <p>&nbsp;&nbsp;5）、为维护医总管的合法权益。
        </p>
        <p>&nbsp;&nbsp;在不透露单个用户隐私资料的前提下，医总管有权对整个用户数据库进行分析利用。
        </p>
        <p>&nbsp;&nbsp;3、医总管对用户注册信息提供最大限度的安全保障。同时，您应对用户密码、个人帐号等信息保密，以免被盗用或窜改。如发现上述情况应立即与医总管联系，或向公安机关报告。
        </p>
        <p>&nbsp;&nbsp;4、为保障用户的合法权益，维护正常的转诊秩序，避免用户因注册资料与真实情况不符而无法享受转诊服务，请转诊用户注册时务必按照真实、全面、准确的原则提供本人信息。对因用户自身原因而造成的不能服务的情形，医总管概不负责。如果用户提供的资料包含有不正确的违法违规信息，医总管保留终止该用户使用本服务的权利。
        </p>
        <p>&nbsp;&nbsp;5、用户需保证自己提供给全科医生的病历等资料真实可靠，否则产生的一切后果由用户自行承担。
        </p>
        <p>&nbsp;&nbsp;6、为维护用户权益、保证服务质量， 医总管在第三方提供服务时均会有相应的服务记录，用户使用平台服务，即表示用户同意医总管对相应的服务过程进行必要的记录。
        </p>
        <p>&nbsp;&nbsp;记录内容包括：
        </p>
        <p>&nbsp;&nbsp;1）、电话预约三方服务通话录音记录，在服务开始前会有系统自动提示。
        </p>
        <p>&nbsp;&nbsp;2）、视频预约客服录像视频记录，在服务开始前会有客服主动提示。
        </p>
        <p>&nbsp;&nbsp;3）、影像预约服务需在指定医院检查，否则无法提取相关影像文件及检查资料供远程专家阅片。
        </p>
        <h4>六 、用户管理</h4>
        <p>&nbsp;&nbsp;1、用户有权随时对自己的个人资料进行查询、修改和删除。但为用户服务安全考虑，用户帐号一经设定即不能随意更改。
        </p>
        <p>&nbsp;&nbsp;2、医总管服务的具体内容由医总管根据实际情况提供，例如签约、转诊、评论等。医总管保留可能变更、中断或终止部分或全部网络服务的权利。
        </p>
        <p>&nbsp;&nbsp;3、医总管在提供网络服务时，可能会对部分网络服务（例如视频预约服务）的用户收取一定的费用。在此情况下，医总管会在相关页面上做明确的提示。如用户拒绝支付该等费用，则不能使用相关的网络服务。
        </p>
        <p>&nbsp;&nbsp;4、用户应理解，医总管仅提供相关的网络平台服务，除此之外与使用网络服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置）及为接入互联网而支付的电话费及上网费等费用均应由用户自行负担。
        </p>
        <h4>七、用户的违约及处理</h4>
        <p>&nbsp;&nbsp;特别提醒您，使用互联网必须遵守国家有关法律法规的规定，如刑法、国家安全法、保密法、计算机信息系统安全保护条例等，保护国家利益及国家安全，对于违法使用互联网络而引起的一切责任，将由您自行承担。
        </p>
        <p>&nbsp;&nbsp;1、不得使用医总管平台产品发送或传播任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽色情性等内容的信息。　
        </p>
        <p>&nbsp;&nbsp;2、不得使用医总管平台发送或传播敏感信息和违反国家法律法规的信息。
        </p>
        <p>&nbsp;&nbsp;3、保证以真实的身份注册使用医总管的软件产品，向医总管所提供的个人身份资料信息真实、完整、有效，依据法律规定和约定对所提供的信息承担相应的法律责任。如果相关信息发生变化的，您应及时更改。
        </p>
        <p>&nbsp;&nbsp;4、在安全完成注册后，您应维持密码及帐号的机密安全。您须对他人利用您的密码及帐号所进行的活动负完全的责任，医总管无法对非法或未经您授权使用您帐号及密码的行为作出甄别，因此医总管平台不承担相关责任。
        </p>
        <p>&nbsp;&nbsp;5、盗取他人号码或利用网络通讯骚扰他人，均属于非法行为。您不得采用测试、欺骗等任何非法手段，盗取其他用户的帐号和对他人进行骚扰。
        </p>
        <p>&nbsp;&nbsp;6、医总管产品属于平台类产品，使用医总管产品服务的医生与用户之间引发的任何纠纷医总管将不承担任何责任。
        </p>
        <h4>八、协议的变更</h4>
        <p>&nbsp;&nbsp;1、医总管可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，适时修改本协议及补充协议，变更后的协议及补充协议（下称“变更事项”）将通过法定程序并以本协议第九条约定的方式通知您。
        </p>
        <p>&nbsp;&nbsp;2、如您不同意变更事项，您有权于变更事项确定的生效日前联系医总管反馈意见。如反馈意见得以采纳，医总管将酌情调整变更事项。
        </p>
        <p>&nbsp;&nbsp;3、如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用医总管平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用医总管平台服务，则视为您同意已生效的变更事项。
        </p>
        <h4>九、通知</h4>
        <p>&nbsp;&nbsp;您同意医总管以以下合理的方式向您送达各类通知：
        </p>
        <p>&nbsp;&nbsp;1、公示的文案；
        </p>
        <p>&nbsp;&nbsp;2、站内信、微信消息、客户端推送的消息；
        </p>
        <p>&nbsp;&nbsp;3、根据您预留于医总管平台的联系方式发出的电子邮件、短信、函件等。
        </p>
        <h4>十、协议的终止</h4>
        <p style="padding: 0;padding-top: 0.5rem">（一）用户发起的终止
        </p>
        <p>&nbsp;&nbsp;您有权通过以下任一方式终止本协议：
        </p>
        <p>&nbsp;&nbsp;1、在满足医总管平台公示的账户注销条件时，您可以通过协同服务中心客服服务注销您的账户；s
        </p>
        <p>&nbsp;&nbsp;2、变更事项生效前您明示不愿接受变更事项并停止使用医总管产品及服务；
        </p>
        <p>&nbsp;&nbsp;3、您明示不愿继续使用医总管平台服务，且符合医总管网终止条件的。
        </p>
        <p style="padding: 0;">（二）医总管发起的终止
        </p>
        <p>&nbsp;&nbsp;出现以下情况时，医总管有权以本协议第九条所列的方式通知您终止本协议：
        </p>
        <p>&nbsp;&nbsp;1、您违反本协议约定，医总管依据相关条款终止本协议的；
        </p>
        <p>&nbsp;&nbsp;2、您有盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，医总管依据医总管平台规则对您的账户予以查封的；
        </p>
        <p>&nbsp;&nbsp;3、除上述情形外，因您多次违反医总管平台规则相关规定且情节严重，医总管依据医总管平台规则对您的账户予以查封的；
        </p>
        <p>&nbsp;&nbsp;4、其它应当终止服务的情况。
        </p>
        <p style="padding: 0;">（三）特别约定：
        </p>
        <p>&nbsp;&nbsp;本协议终止后，医总管仍享有下列权利：
        </p>
        <p>&nbsp;&nbsp;1、选择保存或删除您留存于医总管平台的本协议第五条所列的各类信息的权利；
        </p>
        <p>&nbsp;&nbsp;2、对于您过往的违约行为，医总管仍可依据本协议向您追究违约责任。
        </p>
        <h4>十一、免责声明</h4>
        <p>&nbsp;&nbsp;1、用户同意使用医总管服务所存在的风险由其自己承担；因其使用医总管网络服务而产生的一切后果也自行承担。
        </p>
        <p>&nbsp;&nbsp;2、医总管不担保平台服务一定能满足用户的需要，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。
        </p>
        <h4>十二、服务变更、中断或终止</h4>
        <p>&nbsp;&nbsp;1、如因系统维护或升级的需要而需暂停网络服务，医总管将尽可能事先进行通告。
        </p>
        <p>&nbsp;&nbsp;2、如发生下列任何一种情形，医总管有权随时中断或终止向用户提供本协议项下的网络服务而无需通知用户：
        </p>
        <p>&nbsp;&nbsp;1）、用户提供的个人资料不真实；
        </p>
        <p>&nbsp;&nbsp;2）、用户违反本协议中规定的使用规则。
        </p>
        <p>&nbsp;&nbsp;3）、除前款所述情形外，医总管保留特殊情况下，不事先通知而中断或终止部分或全部网络服务的权利。
        </p>
        <h4>十三、违约赔偿</h4>
        <p>&nbsp;&nbsp;1、由于网络服务的特殊性，因服务器提供方、通讯提供方等第三方原因造成的服务中断或终止，由第三方承担相关赔偿责任，与医总管无关。
        </p>
        <p>&nbsp;&nbsp;2、用户应当遵守本协议及相关规则，如因用户违反法律、法规或本协议项下的任何条款而给医总管或任何其他第三人造成损失，用户应当依法承担相关赔偿责任，与医总管无关。
        </p>
        <h4>十四、法律适用、管辖与其他</h4>
        <p>&nbsp;&nbsp;本协议的订立、执行、解释及争议的解决均适用中华人民共和国大陆地区适用之现行有效的法律（但不包括其冲突法规则）法规之规定。如本协议条款与法律法规相抵触，则该条款应按法律法规之规定重新解释，而其它条款继续有效。如因本协议内容或其执行发生任何争议，各方应友好协商解决；协商不成时，任何一方均有权向医总管平台运营公司所在地法院提起诉讼。
        </p>
        <p>&nbsp;&nbsp;本协议最终解释权属医总管平台运营公司。
        </p>
    </div>
</template>

<script>
    export default{
        data() {
            return{
                year:'',
                month:'',
                day:'',
            }
        },
        created() {
            var date = new Date()
            this.year = date.getFullYear()
            this.month = date.getMonth()+1
            this.day = date.getDate()
        }
    }
</script>

<style lang="scss" scoped>
    .app{
        h4{
            padding-left: 0.5rem;
            font-weight: bold;
        }
        p{
            padding: 0.375rem 0.5rem;
            text-align: justify;
            letter-spacing:2px;
        }
    }
</style>


// WEBPACK FOOTER //
// FamilyArgeeMent.vue?63d882fd